module.exports = __webpack_public_path__ + "media/images/icons/outlined/arrows-alt-b5ff18e5d06a740cc3d38e43996ad0f3.svg";